import { Link } from "react-router-dom";

// Premium typographic wordmark. "FORGE" carries a restrained red spark on the E.
export const Wordmark = ({ className = "", size = "text-lg" }) => (
  <Link to="/" data-testid="wordmark-home" className={`group inline-flex items-center gap-2 ${className}`}>
    <span className="relative flex h-7 w-7 items-center justify-center border border-white/15 bg-panel">
      <span className="block h-2.5 w-2.5 rotate-45 bg-white transition-colors duration-300 group-hover:bg-brand-cyan" />
      <span className="absolute -right-[3px] -top-[3px] h-1.5 w-1.5 bg-brand-ember" />
    </span>
    <span className={`font-display font-extrabold tracking-tight ${size} leading-none`}>
      <span className="text-white">GENUINE</span>
      <span className="text-white/60">&nbsp;FORG</span>
      <span className="relative text-white/60">
        E<span className="absolute -right-1 top-0 h-1 w-1 bg-brand-ember" />
      </span>
    </span>
  </Link>
);

export default Wordmark;
